import MPWApi from 'API/MPWApi';

const getPagesByRoleURI = roleId => `Security/GetPagesByRole/${roleId}`;

export const loadData = async dispatch => {
  return await new Promise((resolve, reject) => {
    MPWApi.getGeneric('Role')
      .then(response => MPWApi.parseResponse(response))
      .then(response => {
        const [roles = [{ Id: 0 }]] = response;

        // Load the first role by default, don't make user select dropdown first.
        return MPWApi.getGenericWithData(getPagesByRoleURI(roles[0].Id), roles);
      })
      .then(data => MPWApi.parseResponse(data))
      .then(data => {
        const [pagesByRole, , args = []] = data;
        const [roles] = args;

        resolve([pagesByRole, roles]);
      });
  });
};

export const loadDataByRoleId = async roleId => {
  return await MPWApi.getGeneric(getPagesByRoleURI(roleId)).then(response =>
    MPWApi.parseResponse(response)
  );
};

export const postData = async data =>
  await MPWApi.postGenericInsertUpdate('Security/WritePagesByRole', data).then(
    data => MPWApi.parseResponse(data)
  );



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/api/Request.js